import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { Spacings } from 'types/Theme';
import { facilityCategories, facilityCategoryTitleMessages, getCategoryFacilities } from 'utils/facilities';
import { Stack } from '@daedalus/atlas/helpers/Stack';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { ContentHotel } from '@findhotel/sapi/dist/types/packages/core/src';
import { CategoryIcon } from './CategoryIcon';
import { IconLoader } from './FacilityIcon';
interface Props {
  facilities: ContentHotel['facilities'];
}
const Header = /*#__PURE__*/styled('h2')({
  name: "Header",
  class: "hjt8818",
  propsAsIs: false
});
const List = /*#__PURE__*/styled('ul')({
  name: "List",
  class: "lpdq7tl",
  propsAsIs: false
});
const Category = ({
  icon,
  heading,
  children
}: {
  icon?: React.ReactNode;
  heading?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  return <section>
      <Header>
        {icon || <IconLoader />}
        {heading || <SkeletonLoader width={120} />}
      </Header>

      {children || <List>
          <li>
            <SkeletonLoader width={100} />
          </li>
          <li>
            <SkeletonLoader width={100} />
          </li>
        </List>}
    </section>;
};
export const FacilitiesList = ({
  facilities
}: Props) => {
  const {
    formatMessage
  } = useIntl();
  if (facilities.length === 0) return null;
  return <Stack space="s800">
      {facilityCategories.map(category => {
      const translatedCategoryTitle = facilityCategoryTitleMessages[category.id];
      const categoryFacilities = getCategoryFacilities(facilities ?? [], category.categories);
      if (categoryFacilities.length === 0) return null;
      return <Category key={category.id} icon={<CategoryIcon categoryId={category.id} />} heading={translatedCategoryTitle && formatMessage(translatedCategoryTitle)}>
            <List>
              {categoryFacilities.map(facility => <li key={facility}>{facility}</li>)}
            </List>
          </Category>;
    })}
    </Stack>;
};

require("./FacilitiesList.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FacilitiesList.tsx");